import applyToOneOrMany from './applyToOneOrMany'

export default function transformFlexContent (data) {
	return applyToOneOrMany(_transformFlexContentPost, data)
}

function _transformFlexContentPost (post) {
	if (post.flex_content) {
		post.flex_content = post.flex_content.map((x) => {
			const s = {}
			s.type = x.acf_fc_layout

			switch (s.type) {
				case 'text':
					// console.log(x)
					s.value = x.rich_text
					break
				case 'images':
					// console.log(x)
					s.images = x.image_repeater.map((x) => {
						const a = {}
						a.imageUrl = x.image.sizes.bandara_medium ? x.image.sizes.bandara_medium : 'image-url'
						a.caption = x.caption ? x.caption : ''
						a.imageSize = x.image_size ? x.image_size : 'full'
						a.imageAltText = x.image.alt ? x.image.alt : (x.caption ? x.caption : '')
						return a
					})

					break
				case 'oembed':
					// console.log(x)
					s.oembedData = {}
					s.oembedData.oembedIs360 = x.oembed_is_360
					s.oembedData.fallbackImage = x.fallback_image
					s.oembedData.oembed = x.oembed
					s.oembedData.videoUrl = x.video_url
					break
				case 'html_snippet':
					// console.log(x)
					s.code = x.code
					s.isFacebookVideo = x.is_facebook_video
					break
				case 'teaser_block':
					// console.log(x)
					s.teaserData = {}
					s.teaserData.title = x.title
					s.teaserData.link_text = x.link_text
					s.teaserData.link_url = x.link_url
					break
			}
			return s
		})
	}
	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformFlexContent.js